import { z } from "zod";
import { auditInfoSchema } from "../common/schemas";

export const workspaceAssignmentViewSchema = z.object({
    id: z.string(),
    workspaceId: z.string(),
    userId: z.string(),
    assigned: auditInfoSchema,
    released: auditInfoSchema.nullable().optional(),
    isOpen: z.boolean(),
});
export type WorkspaceAssignmentView = z.infer<typeof workspaceAssignmentViewSchema>;

export const workspaceAssignmentListResponseSchema = z.object({
    results: z.array(workspaceAssignmentViewSchema),
});

export const workspaceAssignmentMutationResponseSchema = z.object({
    assignment: workspaceAssignmentViewSchema,
    replacedAssignment: workspaceAssignmentViewSchema.nullable().optional(),
});

export interface WorkspaceAssignmentCreatePayload {
    readonly id: string;
    readonly workspaceId: string;
    readonly userId: string;
}

export interface WorkspaceAssignmentMutationResult {
    readonly assignment: WorkspaceAssignmentView;
    readonly replacedAssignment?: WorkspaceAssignmentView | null;
}
